// extracted by mini-css-extract-plugin
export default {"root":"_1HKYB","main":"_21P6c","hidden":"w8dQq","single-image":"cmmuO","singleImage":"cmmuO"};